import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchStandardUrinesApi } from 'api/standard_urine'
import { StandardUrine, StandardUrineSearchForm } from 'entities/standard_urine'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { standardUrineColumnInfoList, StandardUrineTableData } from './standard_urnie_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { Flex } from 'components/shared/flex'
import { EditStandardUrineForm, NewStandardUrineForm } from './standard_urine_form'
import { ProtocolVersion } from 'entities/protocol_version'
import { ProtocolVersionProbesModal } from 'components/protocol_version/protocol_version_probes_modal'

type Props = {
    history: H.History
}

const StandardUrinesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<StandardUrineSearchForm>()
    // const searchForm = useForm<StandardUrineSearchForm>({ ...query, ordering: 'updated_at' })
    const searchForm = useForm<StandardUrineSearchForm>({ ...query })
    const api = useFetchStandardUrinesApi(searchForm)
    const checkIdForm = useMultipleCheckForm<StandardUrine>()
    const standardUrineDisplaySetting = useDisplaySetting(standardUrineColumnInfoList(searchForm), 'StandardUrine')
    const [selectedStandardUrine, setSelectedStandardUrine] = useState<StandardUrine>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [showProbe, setShowProbe] = useState<boolean>(false)
    const [selectedProtocolVersion, setSelectedProtocolVersion] = useState<ProtocolVersion>({})

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        searchForm.set(query)
    }, [query.scope])

    const handleClickRemoveFilter = (key: keyof StandardUrineSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`standard_urines?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <div key={query.scope}>
            <EditStandardUrineForm
                StandardUrine={selectedStandardUrine}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ProtocolVersionProbesModal show={showProbe} protocolVersion={selectedProtocolVersion} onClose={() => setShowProbe(false)} />
            <ContentHeader
                headerTitle={"標準尿一覧"}
                left={
                    <>
                        {query.scope !== 'only_qc' && <NewStandardUrineForm onComplete={() => api.execute()} />}
                        <SearchConditionView
                            searchForm={searchForm}
                            onClickRemoveButton={handleClickRemoveFilter}
                            hiddenSearchParams={['institutionId', 'scope']}
                        />
                    </>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={standardUrineDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={standardUrineDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((StandardUrine: StandardUrine) => {
                                return (
                                    <tr key={`StandardUrine-${StandardUrine.id}`}>
                                        <StandardUrineTableData
                                            standardUrine={StandardUrine}
                                            displaySetting={standardUrineDisplaySetting}
                                        />

                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="StandardUrine"
            ></SelectionFixedFooter>
        </div>
    )
}

export default withRouter(StandardUrinesPage)